var exports = {
  "kL": "xcc377c0b--7ace78--container",
  "aY": "xcc377c0b--7ace78--code",
  "h_": "xcc377c0b--7ace78--description",
  "SD": "xcc377c0b--7ace78--static-preview",
};

module.exports = exports;
